import { ErrorService } from './../utils/error.service';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbTokenService } from '@nebular/auth';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../utils/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private errorService: ErrorService,
    private tokenService: NbTokenService,
    private router: Router,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err?.status === 401) {
          this.tokenService.clear();
          AuthService.resetLocalStorage();
          this.router.navigate(['/auth/login']);
        } else {
          this.errorService.handleError(err, true);
        }
        
        return throwError(() => err);
      }),
    );
  }
}
